export const MonthTabList = [
  { title: 'Jan', value: '1' },
  { title: 'Feb', value: '2' },
  { title: 'Mar', value: '3' },
  { title: 'Apr', value: '4' },
  { title: 'May', value: '5' },
  { title: 'Jun', value: '6' },
  { title: 'Jul', value: '7' },
  { title: 'Aug', value: '8' },
  { title: 'Sept', value: '9' },
  { title: 'Oct', value: '10' },
  { title: 'Nov', value: '11' },
  { title: 'Dec', value: '12' }
];
